import { backendApi } from "@/services/api";
import { type Delivery } from "@/services/backend/deliveries/delivery/delivery";
import { Filter } from "@/shared/lib/filter/filter";
import { DeliveryTemplate } from "./delivery";

const deliveryTemplatesApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    listDeliveryTemplates: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/inspections/delivery-templates`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["DeliveryTemplate"],
    }),
    putDeliveryTemplate: build.mutation<Delivery, PutDeliveryTemplateRequest>({
      query: (request) => ({
        url: `/inspections/delivery-templates`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["DeliveryTemplate"],
    }),
    getDeliveryTemplate: build.query<DeliveryTemplate, GetRequest>({
      query: (request) => ({
        url: `/inspections/delivery-templates/${request.id}`,
        method: "GET",
        params: request,
      }),
      providesTags: (_result, _e, request) => [
        { type: "DeliveryTemplate", id: request.id },
      ],
    }),
  }),
});

export const {
  useGetDeliveryTemplateQuery,
  useListDeliveryTemplatesQuery,
  usePutDeliveryTemplateMutation,
} = deliveryTemplatesApi;

export interface GetRequest {
  id: string;
}

export interface ListRequest {
  customerId: Filter<string>;
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: DeliveryTemplate[];
}

export interface PutDeliveryTemplateRequest {
  deliveryTemplate: DeliveryTemplate;
}
